import React from 'react';
import { Icon } from './Icon.js';
export const IconItinerary3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "11", width: "5.5", height: "5.5", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("circle", { cx: "4.75", cy: "4.25", r: "2.75", fill: "currentColor" }),
        React.createElement("path", { d: "M13.25,3.5h-4c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h4c.689,0,1.25,.561,1.25,1.25v5.5c0,.689-.561,1.25-1.25,1.25h-4c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h4c1.517,0,2.75-1.233,2.75-2.75V6.25c0-1.517-1.233-2.75-2.75-2.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconItinerary3Fill18.js.map